<template>
    <div class="h-screen flex w-full">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404_green.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">Acceso no autorizado</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-10 d-theme-text">Lo sentimos, no encontramos la luz en esta dirección.</p>
            <vs-button size="large" @click.stop="goToHome">Volver al inicio</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "notAuth",
    methods: {
        async goToHome() {
            if (this.UserRole === "client") {
                await this.$router.push({ name: 'inicioSolicitante' });
            }
            else if (this.UserRole === "investor") {
                await this.$router.push({ name: 'inicioInversionista' });
            }
            else if (this.UserRole === "supplier" || this.UserRole === "supplier_agent") {
                await this.$router.push({ name: 'inicio' });
            } else {
                await this.$router.push({ name: 'login' });
            }
        },
    }
}
</script>
